import React, { useCallback, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ReportIcon } from 'src/components/ui-icons/sidebar';
import FilterForPlanAction from 'src/pages/DashboardPage/vpo/components/planAction/filterForPlanAction/FilterForPlanAction';
import { filterConfigFactoryGop, filtersOpenFactoryGop, initialFilterFactoryGop, months, years } from './forFilterDataFactory';
import { divide, isEqual } from 'lodash';
import { fetchReportFactoryRequest } from '../../store/report-factory/report-factory';
import { getDataReportFactory, getDataReportFactoryError, getFetchingStatusReportFactory } from '../../store/report-factory/selectors';
import { useAppDispatch, useAppSelector } from 'src/hooks/redux';
import { selectModelData } from '../../selectors/selectors';
import { fetchData } from '../../actions/actions';
import TableFactory from '../table-factory/table-factory';
import { getBlocksForSelectedDirections, getDepartmentsForSelectedDirectionsAndFactories, getDirectionsForSelectedGOPs, getFactoriesForSelectedGroups, getGOPsForSelectedGroups, transformDataForFilters, transformDataForFiltersGOPs } from '../../utils/reports';
import { fetchCurrentDateRequest } from '../../store/date/date';
import { getCurrentDate } from '../../store/date/selectors';
import { getCurrentQuarterAndYear, getIdQuarter, getLabelQuarter } from '../../utils/utils';
import { QuarterDictionary } from '../../types/data';
import ExportExcelFactory from '../export-excel-factory/export-excel-factory';
import Loading from 'src/components/Loading';

export default function FactoryReport() {
  const [initialFilters, setInitialFilters] = useState<any>(null);
  const [currentFilters, setCurrentFilters] = useState<any>(initialFilterFactoryGop);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const groupGop = useAppSelector((state: any) => selectModelData(state, 'gop-groups'));
  const factoriesGop = useAppSelector((state: any) => selectModelData(state, 'gop-factories'));
  const formGops = useAppSelector((state: any) => selectModelData(state, 'gop-gops'));
  const gopDirection = useAppSelector((state: any) => selectModelData(state, 'gop-directions'));
  const departments = useAppSelector((state: any) => selectModelData(state, 'gop-departments'));

  const currentDate = useAppSelector(getCurrentDate);

  const listNames = ['gop-groups', 'gop-factories', 'gop-gops', 'gop-directions', 'gop-departments'];

  useEffect(() => {
    listNames.forEach((listName) => {
      dispatch(fetchData(listName));
    });
  }, [dispatch]);

  // Получаем текущий квартал
  useEffect(() => {
    dispatch(fetchCurrentDateRequest());
  }, [dispatch]);

  // Устанавливаем текущий квартал для изначальных фильтров
  useEffect(() => {
    if (currentDate) {
      const updatedInitialFilters = {
      ...initialFilterFactoryGop,
      monthGopReropt: {
        selected: [QuarterDictionary[getCurrentQuarterAndYear(currentDate)?.quarter]],
        selectedIds: [getIdQuarter(getCurrentQuarterAndYear(currentDate)?.quarter)],
      },
    };

    setInitialFilters(updatedInitialFilters);
    setCurrentFilters(updatedInitialFilters);
    }
  }, [currentDate]);

  //! Получения заводов для выбранных групп
  const availableFactories = getFactoriesForSelectedGroups(currentFilters, groupGop);
  //! Получения ГОП для выбранных групп
  const availableGOPs = getGOPsForSelectedGroups(currentFilters, groupGop);
  //! Получения Направлений для выбранных ГОП
  const availableDirections = getDirectionsForSelectedGOPs(currentFilters, formGops);
  //! Получения Отделов от направлений и заводов
  const availableDepartments = getDepartmentsForSelectedDirectionsAndFactories(currentFilters, gopDirection, factoriesGop, departments);
  //! Получение блоков требований для выбранных направлений
  const availableBlocks = getBlocksForSelectedDirections(currentFilters, gopDirection);

  //! трансформация данных для фильтров
  const transformedGroupGop = transformDataForFilters(groupGop);
  const transformedFactoriesGop = transformDataForFilters(availableFactories);
  const transformedFormGops = transformDataForFiltersGOPs(availableGOPs);
  const transformedGopDirections = transformDataForFilters(availableDirections);
  const transformedGopBlocks = transformDataForFilters(availableBlocks);
  const transformedDepartments = transformDataForFilters(availableDepartments);

  console.log('currentFilters', currentFilters);

  const filterConfigs = {
    yearGopReropt: { items: years },
    monthGopReropt: { items: months },
    groupGop: { items: transformedGroupGop },
    factoryGop: { items: transformedFactoriesGop },
    formGopAction: { items: transformedFormGops },
    direction: { items: transformedGopDirections },
    department: { items: transformedDepartments },
    blockDemand: { items: transformedGopBlocks },
  };

  const filtersMap = {
    yearGopReropt: years,
    monthGopReropt: months,
    groupGop: transformedGroupGop,
    factoryGop: transformedFactoriesGop,
    formGopAction: transformedFormGops,
    direction: transformedGopDirections,
    department: transformedDepartments,
    blockDemand: transformedGopBlocks,
  };

  const reportFactory = useAppSelector(getDataReportFactory);
  const loadingReportFactory = useAppSelector(getFetchingStatusReportFactory);
  const reportFactoryError = useAppSelector(getDataReportFactoryError);

  const handleFiltersChange = useCallback(
    (newFilters: React.SetStateAction<any>) => {
      if (!isEqual(currentFilters, newFilters)) {
        console.log('Новые фильтры ОТЧЕТЫ:', newFilters);
        setCurrentFilters(newFilters);
      }
    },
    [currentFilters]
  );

  useEffect(() => {
    if (currentFilters) {
      dispatch(
        fetchReportFactoryRequest({
          year: currentFilters.yearGopReropt.selectedIds,
          quarter: getLabelQuarter(currentFilters.monthGopReropt.selectedIds),
          factory: currentFilters.factoryGop.selectedIds,
          gop: currentFilters.formGopAction.selectedIds,
          filters: currentFilters
        })
      );
    }
  }, [currentFilters, dispatch]);

  if (currentFilters) console.log('reportFactory', currentFilters.monthGopReropt.selectedIds);

  console.log("reportFactoryError", reportFactoryError)

  return (
    <div className='flex justify-between w-full h-full'>
      <div className='w-[320px] mr-2 bg-white'>
        {initialFilters &&
          <FilterForPlanAction
            onFiltersChange={handleFiltersChange}
            filterConfigs={filterConfigs}
            filtersMap={filtersMap}
            initialFilters={initialFilters}
            filtersOpen={filtersOpenFactoryGop}
            filtersConfig={filterConfigFactoryGop}
            responsibleFil={true}
            heightFilter={'h-[calc(100vh-2px)]'}
          />
        }
      </div>
      <div className='flex-1 min-w-0 m-6'>
        <div className='flex items-center text-gray-600 mb-6'>
          <span className='pr-3'>
            <ReportIcon />
          </span>
          <span className='cursor-pointer text-base' onClick={() => navigate('/dashboard/2/reports')}>
            Отчеты
          </span>
          <span className='mx-2'>→</span>
          <span className='text-base'>Отчет по заводу</span>

          {reportFactory && <ExportExcelFactory data={reportFactory.data} departments={reportFactory.departments} />}
        </div>
        <>
              {loadingReportFactory
                ?
                  <Loading />
                :
                <>
                  {reportFactory && !reportFactoryError ? <TableFactory data={reportFactory.data} dataHead={reportFactory.departments} /> : reportFactoryError ? <div>Пожалуйста, выберите как минимум один вариант в каждом фильтре</div> : null}
                </>
              }
            </>
      </div>
    </div>
  );
}
